module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-thumbnail.7e256a99.png";